const URL = '/precios';

const state = {
  all: [],
  loading: false,
  options: {
    itemsPerPage: 36,
    page: 1,
    sortBy: [],
    sortDesc: []
  },
  itemsLength: null,
}

// GETTERS
const getters = {
  all (state) {
    return state.all
  },
  itemsLength (state) {
    return state.itemsLength
  },
  options (state) {
    return state.options
  },
  loading (state) {
    return state.loading
  },
  latest (state) {
    if (!state.all.length) return null
    return [...state.all].sort((a, b) => new Date(b.vigencia) - new Date(a.vigencia))[0]
  },
}

// ACTIONS
const actions = {
  onFetch ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL, {
        params: {
          itemsPerPage: state.options.itemsPerPage,
          page: state.options.page,
          sortBy: state.options.sortBy[0],
          sortDesc: state.options.sortDesc[0] ? 1 : 0,
        }
      })
        .then(response => {
          commit('setAll', response.data.data)
          commit('setItemsLength', response.data.meta.total)
          if (state.options.page + state.options.itemsPerPage > response.data.meta.total)
            commit('setPage', 1)
          resolve(response.data.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onVigente({ state }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload || !state.all.length) {
        reject(new Error('Fecha inválida o no hay datos disponibles'))
        return
      }
      const fechaParam = new Date(payload)
      const candidatos = state.all
      .filter(item => new Date(item.vigencia) <= fechaParam)
      .sort((a, b) => new Date(b.vigencia) - new Date(a.vigencia)) // Más reciente primero

      if (candidatos.length) {
        resolve(candidatos[0])
      } else {
        reject(new Error('No hay precios vigentes para la fecha indicada'))
      }
    })
  }
}

// MUTATIONS
const mutations = {
  setAll (state, payload) {
    state.all = payload.slice()
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setPage (state, payload) {
    state.options.page = payload
  },
  setItemsPerPage (state, payload) {
    state.options.itemsPerPage = payload
  },
  setItemsLength (state, payload) {
    state.itemsLength = payload
  },
  setOptions (state, payload) {
    state.options = payload
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
